import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  AvatarInput,
  Button,
  ButtonsWrapper,
  Form,
  PLATFORM_THEME_COLORS,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { usePartialEmployeeUpdate } from 'src/hooks/employees/partial-employee-update.hook';
import { useGetCurrentCompanyId } from 'src/hooks/companies/get-current-company-id.hook';
import { useChangeEmployeeAvatar } from 'src/hooks/employees/change-employee-avatar.hook';
import { PersonalInfo } from 'src/components/employee/personal-info';
import isEmpty from 'lodash/isEmpty';

const PersonalInfoEdit = ({
  onCancel,
  initialValues,
}: {
  onCancel: () => void;
  initialValues: any;
}) => {
  const { t } = useTranslation(['employee', 'common']);
  const [avatar, setAvatar] = useState(initialValues?.profile?.avatarUrl);

  const currentCompanyId = useGetCurrentCompanyId();
  const partialEmployeeUpdate = usePartialEmployeeUpdate({ onSuccess: onCancel });
  const changeEmployeeAvatar = useChangeEmployeeAvatar();

  const onAvatarInputChange = (value: any) => {
    changeEmployeeAvatar({ variables: { memberId: initialValues._id, avatar: value } });
    setAvatar(value);
  };

  const onFinish = (values: any) => {
    const { emergencyContact, ...rest } = values;
    partialEmployeeUpdate({
      variables: {
        payload: {
          _id: initialValues._id,
          memberInput: {
            companyId: currentCompanyId,
            ...rest,
          },
          ...(!isEmpty(emergencyContact) && { emergencyContact }),
        },
      },
    });
  };

  return (
    <div>
      <br />
      <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
        {t('employee:employeePersonalInfo.labels.personalInfo')}
      </Typography>
      <br />
      <AvatarInput size={64} avatar={avatar} squareCoverForm onChange={onAvatarInputChange} />
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          ...initialValues,
          ...initialValues.profile,
          ...initialValues.account,
          employeePersonalInfo: {
            ...initialValues.employeePersonalInfo,
          },
          birthday: initialValues.profile?.birthday ? moment(initialValues.profile.birthday) : null,
        }}
      >
        <PersonalInfo isEdit employeeId={initialValues?._id} />
        <ButtonsWrapper>
          <Button type="primary" htmlType="submit">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={onCancel}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </div>
  );
};

export default PersonalInfoEdit;
